import React from 'react';
import { FiBarChart2 } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

interface NoDataPlaceholderProps {
  className?: string;
  message?: string;
}

export const NoDataPlaceholder: React.FC<NoDataPlaceholderProps> = ({
  className,
  message,
}) => {
  const { t } = useTranslation('Common');
  const displayMessage = message ?? t('noDataAvailableForPeriod');

  return (
    <div
      className={`flex flex-col items-center justify-center h-full text-gray-400 dark:text-gray-500 ${className}`}
    >
      <FiBarChart2 size={40} className="text-gray-400 dark:text-gray-500" />
      <p className="mt-2 text-sm">{displayMessage}</p>
    </div>
  );
};
